'use client'
let didStoreVersionChangedValue = false;
const getDidStoreVersionChangedValue = () => didStoreVersionChangedValue;
const setDidStoreVersionChangedValue = (value) => {
    didStoreVersionChangedValue = value;
};

export { getDidStoreVersionChangedValue, setDidStoreVersionChangedValue };
